
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface Feature {
  title: string;
  description: string;
}

const PublicServiceSection = () => {
  const { t } = useTranslation('individuals');
  const careerFeatures = t('publicService.career.features', { returnObjects: true }) as Feature[];
  const competitionFeatures = t('publicService.competition.features', { returnObjects: true }) as Feature[];

  return (
    <section className="py-24 bg-card">
      <div className="container-custom">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl sm:text-5xl font-bold text-center bg-clip-text text-transparent bg-gradient-to-r from-brand-blue to-brand-orange mb-6">
              {t('publicService.title')}
            </h2>
            <p className="text-xl text-brand-orange mb-8">
              {t('publicService.subtitle')}
            </p>
            <p className="text-lg text-muted-foreground leading-relaxed max-w-4xl mx-auto">
              {t('publicService.description')}
            </p>
          </div>

          <div className="bg-background rounded-2xl p-8 border border-border mb-16">
            <p className="text-muted-foreground leading-relaxed mb-6 italic">
              {t('publicService.testimonial.text')}
            </p>
            <div className="flex items-center gap-4">
              <div>
                <p className="font-semibold text-brand-orange">
                  {t('publicService.testimonial.author')}
                </p>
                <p className="text-sm text-muted-foreground">
                  {t('publicService.testimonial.role')}
                </p>
              </div>
            </div>
          </div>

          <div className="mb-16">
            <h3 className="text-3xl font-bold text-center mb-12 text-brand-blue dark:text-brand-orange">
              {t('publicService.career.title')}
            </h3>
            <div className="grid sm:grid-cols-2 gap-8">
              {careerFeatures.map((feature, index) => (
                <div key={index} className="bg-background rounded-2xl p-8 border border-border hover:shadow-xl transition-all duration-300">
                  <h4 className="text-xl font-semibold text-brand-orange mb-4">
                    {feature.title}
                  </h4>
                  <p className="text-muted-foreground leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
            <div className="bg-background rounded-2xl p-8 border border-border mt-8">
              <p className="text-muted-foreground leading-relaxed mb-4 italic">
                {t('publicService.career.example')}
              </p>
              <p className="text-lg font-medium text-brand-blue dark:text-brand-orange">
                {t('publicService.career.conclusion')}
              </p>
            </div>
            <div className="text-center mt-8">
              <a
                href="/search"
                className="inline-flex items-center px-8 py-4 rounded-lg bg-gradient-to-r from-brand-blue to-brand-orange text-white hover:opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl text-lg"
              >
                {t('publicService.career.cta')}
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-3xl font-bold text-center mb-4 text-brand-blue dark:text-brand-orange">
              {t('publicService.competition.title')}
            </h3>
            <p className="text-xl text-brand-orange text-center mb-12">
              {t('publicService.competition.subtitle')}
            </p>
            <div className="space-y-6">
              {competitionFeatures.map((feature, index) => (
                <div key={index} className="bg-background rounded-2xl p-6 border border-border hover:shadow-lg transition-all duration-300">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                    <h4 className="text-xl font-semibold text-brand-orange sm:w-1/3">
                      {feature.title}
                    </h4>
                    <p className="text-muted-foreground leading-relaxed sm:w-2/3">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center mt-12">
              <p className="text-lg text-brand-blue dark:text-brand-orange mb-8">
                {t('publicService.competition.conclusion')}
              </p>
              <a
                href="/search"
                className="inline-flex items-center px-8 py-4 rounded-lg bg-gradient-to-r from-brand-blue to-brand-orange text-white hover:opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl text-lg"
              >
                {t('publicService.competition.cta')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PublicServiceSection;
